import React, { useCallback, useState, useRef, useEffect } from "react";

import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  updateComment,
  loadDetailPost,
} from "../../../../../../redux/modules/postSlice";

import { InputComments } from "./style";

function TextAreaUpdate({
  post,
  comment,
  setCommentMorePropsFunc,
  setVisiblePropsFunc,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const upDateTextareaRef = useRef(null);
  const [commentText, setCommentText] = useState("");
  const [upDateFocus, setUpDateFocus] = useState("focus");
  const [upDateCommentLength, setUpDateCommentLength] = useState(0);

  useEffect(() => {
    setCommentText(comment.content);
  }, [comment.content]);

  // 댓글 수정후 클릭(수정된 댓글 서버로 전송)
  const onClickCommentUpDateDispatch = useCallback(() => {
    setCommentMorePropsFunc();
    setVisiblePropsFunc();
    const payload = {
      commentId: comment.commentId,
      content: upDateTextareaRef.current.value,
    };

    dispatch(updateComment(payload))
      .unwrap()
      .then((res) => {
        dispatch(loadDetailPost(post.boardId));
        navigate(`/boards/${post.boardId}`);
      });
  }, [
    setCommentMorePropsFunc,
    setVisiblePropsFunc,
    dispatch,
    comment.commentId,
    post.boardId,
  ]);

  const onChangeUpDateComment = useCallback(
    (e) => {
      setCommentText(e.target.value);
      setUpDateCommentLength(e.target.value.length);

      // 자동높이조절
      upDateTextareaRef.current.style.height = "auto";
      upDateTextareaRef.current.style.height = `${upDateTextareaRef.current.scrollHeight}px`;
    },
    [upDateCommentLength],
  );

  return (
    <InputComments>
      <textarea
        ref={upDateTextareaRef}
        className={upDateFocus}
        type="text"
        rows="1"
        maxLength="80"
        placeholder="댓글을 입력해 주세요"
        value={commentText}
        autoFocus
        onFocus={() => setUpDateFocus("focus")}
        onBlur={() => setUpDateFocus("blur")}
        onChange={(e) => onChangeUpDateComment(e)}
      />
      {(upDateFocus === "focus" || upDateCommentLength > 0) && (
        <div
          className="textareaAside"
          onClick={() => {
            upDateTextareaRef.current.focus();
          }}
        >
          <div>{upDateCommentLength}/80</div>
          <button
            className={upDateCommentLength > 0 ? "orange" : "black"}
            onClick={onClickCommentUpDateDispatch}
          >
            등록
          </button>
        </div>
      )}
    </InputComments>
  );
}

export default TextAreaUpdate;
